import { useState, useEffect } from "react";
import "./blog.scss";
import { NavLink } from "react-router-dom";

const Blog = ({ title = true, dis = true, link = "/", data }) => {
  return (
    <div className="col-lg-3 col-md-4 col-6">
      {" "}
      <div className="container-item3 ">
        <div className="item text-center pb-2 pt-3 mx-2">
          <div className="position-relative item-img">
            <img
              src={"http://grc.tatdemo.ir/" + data.image}
              className="img"
              // width="80%"
              // height={221}
              alt
            />
            <div className="position-absolute img-gradient" />
          </div>
          <div
            className="bg-white mx-3 text-start pt-2 text my-3"
            // style={{ height: "225px" }}
          >
            {title && (
              <p
                className="mx-3 two-line"
                style={{ fontSize: 17, fontWeight: 600, height: "50px" }}
              >
                {data.title}
              </p>
            )}
            {dis && (
              <div className="main-text mx-3">
                <p className="text-color" style={{ fontSize: 13 }}>
                  {data.description}
                </p>
              </div>
            )}
            <NavLink
              className="text-danger cont text-decoration-none mx-3"
              to={`/article/${data.id}`}
            >
              ادامه مطلب &gt;&gt;
            </NavLink>
            <hr className="text-secondary" />
            <div className="d-flex flex-row justify-content-between mx-3 date">
              <div>
                <p>{data.date != "Invalid Date" && data.date}</p>
              </div>
              <div>
                <p>{data.writer}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
